import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import favIcon from "Assets/newicons/action/favorite/glyph/favorite-glyph-red-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import { withSnackbar } from "notistack";
import React from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { connect } from "react-redux";
import { getFormattedImageLink } from "Utils";
import Details from "./Details";
import Feedback from "./Feedback";
import Notes from "./Notes";
import ScheduleActivity from "./ScheduleActivity";
import Screeningquestion from "./Screeningquestion";

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

class CandidateDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      tabId: this.props.viewResume ? 1 : this.props.viewCoverLetter ? 2 : 0,
      candidateDetails: [],
      activityList: [],
      isapicall: false,
    };
    this.handleVerticalChange = this.handleVerticalChange.bind(this);
  }

  handleVerticalChange(id) {
    this.setState({
      tabId: id,
    });
  }

  componentDidMount() {
    this.getPipelineList();
    this.getCandidateActivity();
    // const windowurl = window.location.pathname.split("/");
    // const tabpipelineid = windowurl[windowurl.length - 2];
    // this.setState({ tabpipelineid });
  }

  getCandidateActivity = async () => {
    try {
      const arrResult = await instance.get(
        `recruit/getcandidateactivity/${this.props.candidateid}`,
      );
      this.setState({
        activityList: arrResult.data.result,
        isapicall: true,
      });
    } catch (error) {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    }
  };

  resetApiCall = () => {
    this.setState({
      isapicall: false,
    });
  };

  componentWillUnmount() {}

  getPipelineList() {
    console.log("HERE?")
    instance
      .get(`recruit/getcandidateapplicationbyid/${this.props.candidateid}`)
      .then((result) => {
        this.setState({ candidateDetails: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  render() {
    const { tabId, candidateDetails } = this.state;

    const resumePath = candidateDetails[0]?.resumepath;
    const coverLetterPath = candidateDetails[0]?.coverletterpath;

    const formattedResumeLink = getFormattedImageLink(resumePath);
    const formattedCoverLetterLink = getFormattedImageLink(coverLetterPath);

    const formattedResumeType = resumePath?.split(".")[1];
    const formattedCoverLetterType = coverLetterPath?.split(".")[1];

    const resumeDocs = [
      {
        uri: formattedResumeLink,
        fileType: formattedResumeType,
      },
    ];

    const coverLetterDocs = [
      {
        uri: formattedCoverLetterLink,
        fileType: formattedCoverLetterType,
      },
    ];

    return (
      <div>
        <div>
          <div className="margin-bottom-16 display-flex">
            <span
              className=" margin-right-16 cursor-pointer"
              onClick={() => this.props.backtomainPage()}
            >
              <img src={backArrow}></img>
            </span>
            <span className=" normal-dark-secondary t-bold margin-right-8">
              {this.props.candidatename}
            </span>
            {this.props.isfavorite && (
              <img src={favIcon} className=" margin-right-8 margin-top-2"></img>
            )}
          </div>
          <Grid container spacing={3}>
            <Grid item md={3} sm={12}>
              <Paper
                className="rounded-rectangle-paper"
                style={{
                  height: "78vh",
                  boxSizing: "border-box",
                  padding: "16px 0px",
                }}
              >
                <VerticalTabs
                  value={tabId}
                  indicatorColor="primary"
                  textColor="primary"
                  className="right-border cursurpointer"
                >
                  <MyTab
                    label="Candidate details"
                    onClick={() => this.handleVerticalChange(0)}
                    className={
                      tabId == 0
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Resume"
                    onClick={() => this.handleVerticalChange(1)}
                    className={
                      tabId == 1
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Cover Letter"
                    onClick={() => this.handleVerticalChange(2)}
                    className={
                      tabId == 2
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Screening questions"
                    onClick={() => this.handleVerticalChange(3)}
                    className={
                      tabId == 3
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Scheduled activities"
                    onClick={() => this.handleVerticalChange(4)}
                    className={
                      tabId == 4
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Notes"
                    onClick={() => this.handleVerticalChange(5)}
                    className={
                      tabId == 5
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                  <MyTab
                    label="Feedback"
                    onClick={() => this.handleVerticalChange(6)}
                    className={
                      tabId == 6
                        ? "vertical-tab-item-selected"
                        : "vertical-tab-item"
                    }
                  />
                </VerticalTabs>
              </Paper>
            </Grid>
            <Grid item md={9} sm={12}>
              <Paper
                className="rounded-rectangle-paper padding16"
                style={{ boxSizing: "border-box" }}
              >
                {tabId == 0 && (
                  <TabContainer>
                    <Details
                      {...this.state}
                      candidateDetails={this.state.candidateDetails}
                      candidateDesignation={this.props.candidatedesignation}
                      getPipelineList={this.getPipelineList}
                    />
                  </TabContainer>
                )}
                {tabId == 1 && (
                  <TabContainer>
                    <div>
                      {candidateDetails &&
                      candidateDetails[0] &&
                      candidateDetails[0].resumepath ? (
                        <DocViewer
                          pluginRenderers={DocViewerRenderers}
                          documents={resumeDocs}
                          config={{
                            header: {
                              disableHeader: true,
                              disableFileName: true,
                              retainURLParams: false,
                            },
                          }}
                          style={{ height: "75vh" }}
                        />
                      ) : (
                        <p className="normal-dark">No resume uploaded</p>
                      )}
                    </div>
                  </TabContainer>
                )}
                {tabId == 2 && (
                  <TabContainer>
                    <div>
                      {candidateDetails &&
                      candidateDetails[0] &&
                      candidateDetails[0].coverletterpath ? (
                        <DocViewer
                          pluginRenderers={DocViewerRenderers}
                          documents={coverLetterDocs}
                          config={{
                            header: {
                              disableHeader: true,
                              disableFileName: true,
                              retainURLParams: false,
                            },
                          }}
                          style={{ height: "75vh" }}
                        />
                      ) : (
                        <p className="normal-dark">No cover letter uploaded</p>
                      )}
                    </div>
                  </TabContainer>
                )}
                {tabId == 3 && (
                  <TabContainer>
                    <Screeningquestion
                      {...this.state}
                      candidateDetails={this.state.candidateDetails}
                      getPipelineList={this.getPipelineList}
                    />
                  </TabContainer>
                )}
                {tabId == 4 && (
                  <TabContainer>
                    <ScheduleActivity
                      activityList={this.state.activityList}
                      getCandidateActivity={this.getCandidateActivity}
                      resetApiCall={this.resetApiCall}
                      isapicall={this.state.isapicall}
                      employeeList={this.props.employeeList}
                      alltimezone={this.props.alltimezone}
                      isparticipant={this.props.isparticipant}
                      selectedrow={this.props.selectedrow}
                    />
                  </TabContainer>
                )}
                {tabId == 5 && (
                  <TabContainer>
                    <Notes
                      {...this.state}
                      candidateid={this.props.candidateid}
                      candidateempid={this.props.candidateempid}
                      pipelinestageid={this.props.pipelinestageid}
                      stagename={this.props.stagename}
                    />
                  </TabContainer>
                )}
                {tabId == 6 && (
                  <TabContainer>
                    <Feedback
                      {...this.state}
                      candidateid={this.props.candidateid}
                      candidateempid={this.props.candidateempid}
                      pipelinestageid={this.props.pipelinestageid}
                      stagename={this.props.stagename}
                      candidateDesignation={this.props.candidatedesignation}
                    />
                  </TabContainer>
                )}
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles(() => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return <div>{props.children}</div>;
}
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(CandidateDetails)),
);
